const BASE_URL = "https://anantaaradhyabackend.onrender.com";

// ===== ACTIVE ENDPOINTS =====

export const healthEndPoint = {
        HEALTH_CHECK_API : BASE_URL + "/health",
}

export const authEndPoints = {
        SIGNUP_API : BASE_URL + "/signup",
        LOGIN_API : BASE_URL + "/login",
        GET_USER_API : BASE_URL + "/get-user",
        // GET_USER_BY_ID_API : BASE_URL + "/auth/getUserById",
        // UPDATE_IMAGE_ID_API : BASE_URL + "/auth/updateImage",
        // UPDATE_PHONE_NUM_ID_API : BASE_URL + "/auth/updatePhoneNum",
        // CHANGE_PASSWORD_API : BASE_URL + "/auth/changePassword",
        // RESET_PASSWORD_TOKEN_API : BASE_URL + "/auth/resetPasswordToken",
        // RESET_PASSWORD_API : BASE_URL + "/auth/resetPassword",
        // CONTACT_US_API : BASE_URL + "/auth/contactUs",
}

export const astrologyEndPoint = {
        PANCHANG_API : BASE_URL + "/astrology/panchang/advanced",
        DAILY_HOROSCOPE_ADVANCED_API : BASE_URL + "/horoscope/daily/advanced",
        KUNDLI_API : BASE_URL + "/astrology/kundli",
        KUNDLI_ADVANCED_API : BASE_URL + "/astrology/kundli/advanced",
        KUNDLI_MATCHING_API : BASE_URL + "/astrology/kundli-matching",
        FESTIVALS_API : BASE_URL + "/festivals",
}

export const musicEndPoint = {
        GET_ALL_MUSIC_API : BASE_URL + "/music",
        GET_MUSIC_BY_ID_API : BASE_URL + "/music",
}

// ===== ADDITIONAL ENDPOINTS (USED BY COMPONENTS) =====

export const sectionEndPoint = {
        GET_SECTION_NAME_API : BASE_URL + "/section/getSectionName",
        GET_SECTION_BY_NAME_API : BASE_URL + "/section/getSectionByName",
        GET_FULL_SECTION_API : BASE_URL + "/section/getFullSection",
        CREATE_SECTION_API : BASE_URL + "/section/createSection",
}

// export const couponEndPoint = {
//         CREATE_COUPNE_API : BASE_URL + "/coupon/createCoupne",
//         GET_COUPNE_API : BASE_URL + "/coupon/getCoupne",
//         DELETE_COUPNE_API : BASE_URL + "/coupon/deleteCoupne",
// }

export const subsectionEndPoint = {
        CREATE_ARTI_API : BASE_URL + "/subsection/createArti",
        CREATE_CHALIS_API : BASE_URL + "/subsection/createChalisa",
        CREATE_MANTRA_API : BASE_URL + "/subsection/createMantra",
        GET_SUBSECTION_BY_ID_API : BASE_URL + "/subsection/getSubsectionById",
        GET_FULL_SUBSECTION_API : BASE_URL + "/subsection/getFullSubSection",
        DELETE_SUBSECTION_API : BASE_URL + "/subsection/deleteSubSection",
        CREATE_BLOG_API : BASE_URL + "/subsection/createBlogSection",
}

export const templeEndPoint = {
        CREATE_TEMPLE_LOCATION_API : BASE_URL + "/temple/createLoc",
        CREATE_TEMPLE_DETAILS_API : BASE_URL + "/temple/createTempleDetail",
        GET_ALL_TEMPLE_API : BASE_URL + "/temple/getTemple",
        GET_TEMPLE_BY_ID_API : BASE_URL + "/temple/getTempleById",
        GET_TEMPLE_BY_LOC_API : BASE_URL + "/temple/getTempleByLocId",
}

// ===== COMMENTED OUT ENDPOINTS (NOT CURRENTLY USED) =====

// export const reviewEndPoint = {
//         CREATE_REVIEW_API : BASE_URL + "/review/createReview",
//         GET_ALL_REVIEW_API : BASE_URL + "/review/getReview",
// }